import React, {useContext} from 'react';
import { Modal, Button, Card, Col, Image } from 'react-bootstrap';
import {
    FaShapes,
    FaClone,
    FaCalendarAlt,
    FaLanguage,
    FaClock,
    FaCoins, FaClipboardList, FaCheckCircle
} from 'react-icons/fa';
import moment from 'moment';
import Row from "react-bootstrap/Row";
import {FaCircleQuestion} from "react-icons/fa6";
import {updatePoolItem} from "../../http/poolAPI";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {USER_DASHBOARD_ROUTE} from "../../utils/consts";
import {Context} from "../../index";
import {addUserLog} from "../../http/userLogAPI";
import {toast} from "react-toastify";
import noImagePoll from "../../assets/no-image-poll.jpg";

const TakeThisPollItem = ({ show, handleClose, pollitem, isYourPoll }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { user, poolStore } = useContext(Context);


    if (!pollitem) return null;

    const pollTypeMap = {
        'COVER_POLL': 'Cover Poll',
        'TITLE_POLL': 'Title Poll',
        'COVER_TITLE_POLL': 'Cover & Title Poll',
        'DESCRIPTION_POLL': 'Description Poll',
        'MIXED_POLL': 'Mixed Poll',
    };

    const pollWhatToDoMap = {
        'COVER_POLL': 'Carefully review all the presented book covers (up to 8). Rate each one, write a short comment answering the author\'s question, and select the cover you believe is the best.',
        'TITLE_POLL': 'Read all the proposed book titles (up to 8). Rate each title, write a brief comment explaining your opinion, and choose the title you consider most suitable.',
        'COVER_TITLE_POLL': 'Evaluate the presented combinations of covers and titles (up to 8). For each pair, rate them, provide a short comment answering the author\'s question, and select the combination you believe works best.',
        'DESCRIPTION_POLL': 'Read all the provided book descriptions (up to 8). Rate each one, write a brief comment sharing your thoughts, and choose the description you find most engaging or appropriate.',
        'MIXED_POLL': 'This survey includes a mix of covers, titles, and descriptions (up to 8 items). For each item, rate it, write a short comment answering the author\'s question, and select the option you think is the best overall.'
    };

    const pollWhatToDo = pollWhatToDoMap[pollitem?.pool?.pool_type] || 'Unknown';
    const pollTypeLabel = pollTypeMap[pollitem?.pool?.pool_type] || 'Unknown';
    const activeItems = Array.from({ length: 8 }).filter((_, i) => pollitem?.pool?.[`pool_item${i + 1}_flag`]);


    const editPollItemWhenCloseSurveyModal = async () => {
        try {
            const updatedItem = {
                itemId: pollitem.id,
                respondent_id: null,
                respondentId: null,
                respondent_name: null,
                respondent_step: "STEP0",
                start_date: null,
                end_date: null,
                pool_item1_rating: null,
            };

            // Отправляем обновленные данные на сервер
            await updatePoolItem(updatedItem);
            console.log("Poll item successfully updated.");
        } catch (error) {
            console.error("Error updating poll item:", error);
            alert("An error occurred while updating the poll item. Please try again later.");
        }
    };


    const ModalClose = async () => {
        setLoading(true);
       await editPollItemWhenCloseSurveyModal();
        setLoading(false);
        handleClose();
    };
    const pollLabel = pollTypeMap[pollitem?.pool?.pool_type] || 'Unknown Poll';

    const takeThisPollItem = async () => {
        setLoading(true);
        await addUserLog(
            user?.user?.id,
            0, user?.user?.balance,
            "Take Poll",
            `You started a ${pollLabel} #${pollitem?.pool?.id}-${pollitem?.id}. Upon completion, you will receive ${pollitem?.pool?.default_price || 50} Virt (Postpaid).`,
            user?.user?.level_of_trust,
            user?.user?.amz_name,
            user?.user?.audible_name,
            user?.user?.email,
            `User start PollItem ID: ${pollitem?.id}`,
            Math.floor(new Date().getTime() / 1000),
            `Poll Item ID: ${pollitem?.id} is taken by Respondent ID: ${user?.user?.id}`,
            null,null, null, null, null, null, null, pollitem?.pool?.id, pollitem?.id,

        );
        const timeToAnswer = pollitem?.time_to_answer / 60 || 0;

       toast.info(`Poll Started. You have ${timeToAnswer} Hours. `, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

        poolStore.setSelectedPoolItem(pollitem);
        navigate(USER_DASHBOARD_ROUTE);
        setLoading(false);
        handleClose();
    }

    const activeItemsX = [
        { image: pollitem?.pool?.pool_item1_image },
        { image: pollitem?.pool?.pool_item2_image },
        { image: pollitem?.pool?.pool_item3_image },
        { image: pollitem?.pool?.pool_item4_image },
        { image: pollitem?.pool?.pool_item5_image },
        { image: pollitem?.pool?.pool_item6_image },
        { image: pollitem?.pool?.pool_item7_image },
        { image: pollitem?.pool?.pool_item8_image }
    ].filter(item => item.image);

    const imagesToRender = Array.from({ length: 8 }, (_, i) => {
        const isActive = pollitem?.pool?.[`pool_item${i + 1}_flag`];
        const image = pollitem?.pool?.[`pool_item${i + 1}_image`];
        return isActive
            ? {
                image: image ? `${process.env.REACT_APP_API_URL}pools/${image}` : noImagePoll
            }
            : null;
    }).filter(Boolean);



    return (
        <Modal show={show} onHide={ModalClose} centered size="lg" backdrop="static" keyboard={false}>
            <Modal.Header closeButton className="small" style={{ height: 40 }}>
                <Modal.Title className="fs-5">Take This Poll (Beta Mode)</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card.Body className="d-flex flex-column small" style={{ lineHeight: "1.4" }}>
                    <div className="d-flex justify-content-center small gap-1">
                        <Row className="w-100">
                            <Col md={6} className="d-flex justify-content-center align-items-center position-relative"
                                 style={{
                                     borderRadius: "6px",
                                     overflow: "hidden",
                                     backgroundColor: "white",
                                     maxHeight: '280px',
                                     paddingLeft: '4px',
                                 }}
                            >
                                {imagesToRender.length === 1 ? (
                                    <Image
                                        src={imagesToRender[0].image}
                                        style={{
                                            objectFit: 'contain',
                                            borderRadius: '8px',
                                            maxHeight: '140px',
                                            maxWidth: '88px',
                                            backgroundColor: 'white',
                                        }}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            display: 'grid',
                                            gap: '4px',
                                            width: '100%',
                                            height: '100%',
                                            alignItems: 'center',
                                            justifyItems: 'center',
                                            gridTemplateColumns:
                                                imagesToRender.length >= 6
                                                    ? 'repeat(3, 1fr)'
                                                    : imagesToRender.length >= 3
                                                        ? 'repeat(3, 1fr)'
                                                        : 'repeat(2, 1fr)',
                                        }}
                                    >
                                        {imagesToRender
                                            .slice(
                                                0,
                                                imagesToRender.length >= 6
                                                    ? 6
                                                    : imagesToRender.length >= 3
                                                        ? 3
                                                        : 2
                                            )
                                            .map((item, index) => (
                                                <Image
                                                    key={index}
                                                    src={item.image}
                                                    style={{
                                                        width: '100%',
                                                        height: 'auto',
                                                        objectFit: 'contain',
                                                        maxHeight:
                                                            imagesToRender.length === 2
                                                                ? '200px'
                                                                : imagesToRender.length >= 3 && imagesToRender.length <= 5
                                                                    ? '150px'
                                                                    : '100px',
                                                        backgroundColor: 'white',
                                                    }}
                                                />
                                            ))}
                                    </div>
                                )}

                            </Col>

                        <Col md={6} className="flex-column justify-content-lg-start align-text-top p-3">
                            <div className="text-muted mt-auto" style={{ fontSize: '0.95rem', lineHeight: '1.4rem'}}>
                                <p className="mb-1 text-success text-truncate"
                                   style={{
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1,
                                       fontSize: '1.2rem'
                                   }}
                                >
                                    <strong>{pollTypeLabel} by {pollitem?.pool?.owner?.slice(0, 3) + '*****'}</strong>
                                </p>
                                <div>
                                    <FaShapes className="me-1" />
                                    Type: <strong>{pollTypeLabel}</strong>
                                </div>
                                <div>
                                    <FaClone className="me-1" />
                                    Items: <strong>{activeItems.length || '1'} Survey Item(s)</strong>
                                </div>
                                <div>
                                    <FaCalendarAlt className="me-1" />
                                    Created: <strong>{moment(pollitem.createdAt).format('DD-MMM-YYYY')}</strong>
                                </div>
                                <div>
                                    <FaLanguage className="me-1" />
                                    Language: <strong>{pollitem?.pool?.language}</strong>
                                </div>
                                <div>
                                    <FaClock className="me-1" />
                                    Time to Answer: <strong>{(pollitem.time_to_answer / 60).toFixed(0)} Hours</strong>
                                </div>

                                <div>
                                    <FaCoins className="me-1" />
                                    Earnings: <strong className="text-success">{pollitem?.pool?.default_price || 100} Virt Postpaid</strong>
                                </div>
                                <div>
                                    <FaCheckCircle className="me-1  text-success " style={{ position: 'relative', top: '-3px' }}  />
                                    <strong className="text-success ">Payment after Completion</strong>
                                </div>


                            </div>
                        </Col>
                        </Row>
                    </div>
                        <div className="d-flex justify-content-center text-success mt-3 gap-1">
                            <Row>
                                <div>
                                    <FaCircleQuestion className="me-1" />
                                    Question: <span className="text-success text-muted fst-italic">"{pollitem?.pool?.question}"</span>
                                </div>
                                <div className="mt-2">
                                    <FaClipboardList className="me-1 " />
                                    What ToDo: <span className="fst-italic text-muted">{pollWhatToDo}</span>
                                </div>
                            </Row>
                        </div>

                </Card.Body>
            </Modal.Body>
            <Modal.Footer style={{ height: 60 }}>
                <Button variant="secondary" className="btn btn-sm" onClick={ModalClose} disabled={loading}>
                    Close
                </Button>
                <Button variant="success" className="btn btn-sm" onClick={takeThisPollItem} disabled={isYourPoll || loading}>
                    {isYourPoll ? "This is Your Poll" : 'Take Poll'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TakeThisPollItem;
